import styled from 'styled-components'

import { type ISortableTagsProps } from '../../../SortableTags'

export const SortableTagsContainerStyled = styled.div<
  Partial<ISortableTagsProps>
>`
  > div {
    ${(props) =>
      props.layout === 'x' ? 'display: flex;' : 'display: inline-block;'}
  }
`
